import type { MtLayoutProps } from '@presentation/components';
import { LanguageSelector } from '@presentation/components/Header/components/LanguageSelector';
import type { FC } from 'react';
import { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { TbX } from 'react-icons/tb';
import { Navigation } from '../Navigation';
import * as Styled from './styled';

export const MobileHeader: FC<MtLayoutProps> = (props) => {
  const { navbarLinkCategories, onLogoutClick, notificationsPanel, languageSelectorButtons } =
    props;
  const [isNavOpen, setIsNavOpen] = useState(false);

  return (
    <Styled.Wrapper>
      <Styled.NotificationsWrapper>{notificationsPanel}</Styled.NotificationsWrapper>

      <Styled.OpenButton
        htmlFor="mobile-header-drawer"
        tabIndex={0}
        aria-haspopup="true"
        role="button"
        aria-controls="menu"
      >
        <FaBars />
      </Styled.OpenButton>

      <Styled.Input
        type="checkbox"
        id="mobile-header-drawer"
        aria-checked={isNavOpen}
        onChange={(e) => {
          const isOpen = e.target.checked;
          setIsNavOpen(isOpen);
          document.body.style.overflow = isOpen ? 'hidden' : '';
        }}
      />
      <Styled.Overlay data-drawer-overlay htmlFor="mobile-header-drawer" />
      <Styled.Drawer data-drawer-content>
        <Styled.DrawerClose htmlFor="mobile-header-drawer">
          <TbX />
        </Styled.DrawerClose>

        <Styled.DrawerContainer>
          <Navigation
            navbarLinkCategories={navbarLinkCategories}
            onLogoutClick={onLogoutClick}
            isMobile
          />
          <Styled.LanguageSelectorWrapper>
            <LanguageSelector color="dark" languageSelectorButtons={languageSelectorButtons} />
          </Styled.LanguageSelectorWrapper>
        </Styled.DrawerContainer>
      </Styled.Drawer>
    </Styled.Wrapper>
  );
};
